import { Component, OnInit } from '@angular/core';
import { LocalStorageService } from '@gah-core/services/local-storage.service';
import { SessionStorageService } from '@gah-core/services/session-storage.service';
@Component({
  selector: 'app-link-expire',
  templateUrl: './link-expire.component.html',
  styleUrls: ['./link-expire.component.scss'],
})
export class LinkExpireComponent {
  constructor(
    private sessionStorage: SessionStorageService,
    private localStorageService: LocalStorageService
  ) {
    this.sessionStorage.removeAll();
    this.localStorageService.removeAll();
  }
}
